// Copilot state management with Jotai
import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";
import { copilotApi } from "./copilot.api";

// Dirty flag - tracks if conversations need refresh (set when message sent)
const conversationsDirtyAtom = atom(false);

// Refresh trigger - increment to invalidate cache
const conversationsRefreshAtom = atom(0);

// Conversations atom that refetches when refresh counter changes
export const conversationsAtom = atom(async (get) => {
  get(conversationsRefreshAtom); // Subscribe to refresh trigger
  return await copilotApi.getConversations(0, 50);
});

// Function atom to mark conversations as dirty (needs refresh)
export const markConversationsDirtyAtom = atom(null, (_get, set) => {
  set(conversationsDirtyAtom, true);
});

// Function atom to refresh conversations if dirty
export const refreshConversationsIfDirtyAtom = atom(
  (get) => get(conversationsDirtyAtom), // Getter returns dirty state
  (get, set) => {
    // Setter only refreshes if dirty flag is set
    if (get(conversationsDirtyAtom)) {
      set(conversationsRefreshAtom, (prev) => prev + 1);
      set(conversationsDirtyAtom, false); // Clear dirty flag
    }
  }
);

// Active conversation ID (persisted to sessionStorage)
export const activeConversationIdAtom = atomWithStorage<number | undefined>(
  "copilot:activeConversationId",
  undefined
);
